<template>
  <div class="newsList">
    <div v-if="objProps.type==='text'">
      <module-title :title="objProps.title" :icon="objProps.icon" class="module-title">
        <div v-if="dataList.length>0" class="right handle-text">
          <router-link :to="{ name: objProps.link, params: { id: 'all'}}">
            更多→
          </router-link>
        </div>
      </module-title>
      <div v-if="dataList.length>0" v-loading="objProps.loading" class="news-item-warp">
        <div v-for="(item,index) in dataList" :key="item.id" class="news-item">
          <div v-if="index===0" class="coverUrl">
            <router-link :to="{ name: 'Detail', params: { id: item.id},query:{source:objProps.source}}">
              <div class="image-warp">
                <img :src="item.coverUrl?item.coverUrl:require('@/assets/img/defaultSchool.png')">
              </div>
              <span :title="item.title" class="title-cover">{{ item.title }}</span>
            </router-link>
          </div>
          <div v-else>
            <router-link
              :to="{ name: 'Detail', params: { id: item.id},query:{
                source: objProps.source
              }}"
              :title="`${item.classifyName?'【'+item.classifyName+'】':''}${item.title}`"
            >
              <span v-show="item.classifyName">【{{ item.classifyName }}】</span>{{ item.title }}
              <span v-show="item.recommendStatus"><img :src="require('@/assets/img/hot.png')" alt=""></span>
            </router-link>
            <span class="right time">{{ item.createDate|monthDay }}</span>
          </div>
        </div>
      </div>
      <global-empty
        v-else
        height="400"
        :label="`暂无数据~`"
        link-it="3"
      />
    </div>
    <div v-else-if="objProps.type==='imgText'" class="imgText">
      <module-title :title="objProps.title" :icon="objProps.icon" class="module-title">
        <span v-if="informationType && informationType.length>0">
          <span v-for="(item,index) in informationType" :key="item.id" :title="item.classifyName" class="classify"> <router-link :to="{ name: objProps.link, params: { id: item.id}}">{{ item.classifyName }}</router-link><span v-if="index!==informationType.length-1">/</span></span></span>
        <div v-if="dataList.length>0" class="right handle-text">
          <router-link :to="{name: objProps.link, params: { id: 'all'}}">
            更多→
          </router-link>
        </div>
      </module-title>
      <div v-loading="objProps.loading" class="message-main">
        <div v-if="dataList.length>0" class="announcement">
          <el-row>
            <el-col v-if="dataList[0].coverUrl" :span="9">
              <div class="coverUrl">
                <router-link :to="{ name: 'Detail', params: { id: dataList[0].id},query:{source:objProps.source}}">
                  <img :src="dataList[0].coverUrl" height="100%">
                  <span :title="dataList[0].title">{{ dataList[0].title }}</span>
                </router-link>
              </div>
            </el-col>
            <el-col :span="dataList[0].coverUrl ? 15 : 24">
              <div v-for="item in dataList.slice(1)" :key="item.id" class="announcement-item">
                <div class="announcement-item-main">
                  <router-link :to="{ name: 'Detail', params: { id: item.id},query:{source:objProps.source}}">
                    <div class="title">
                      <span :title="item.title">
                        {{ item.title }}
                      </span>
                      <i v-show="item.createDate" class="time">
                        {{ item.createDate|yearMonth }}
                      </i>
                    </div>
                    <div class="content">
                      // eslint-disable-next-line vue/no-v-html
                      <div class="text" :title="item.content" v-html="item.contentAbstract" />
                    </div>
                  </router-link>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <global-empty
          v-else
          :label="`暂无数据~`"
          height="400"
          link-it="3"
        />
      </div>
    </div>
    <div v-else-if="objProps.type==='imgTextUpDown'" class="imgTextUpDown">
      <module-title :title="objProps.title" :icon="objProps.icon" class="module-title">
        <span v-if="informationType && informationType.length>0">
          <span v-for="(item,index) in informationType" :key="item.id" :title="item.classifyName" class="classify"> <router-link :to="{ name: objProps.link, params: { id: item.id}}">{{ item.classifyName }}</router-link><span v-if="index!==informationType.length-1">/</span></span></span>
        <div v-if="dataList.length>0" class="right handle-text">
          <router-link :to="{name: objProps.link, params: { id: 'all'}}">
            更多→
          </router-link>
        </div>
      </module-title>
      <div v-loading="objProps.loading" class="message-main">
        <div v-if="dataList.length>0" class="announcement">
          <el-row>
            <el-col :span="12">
              <div class="coverUrl">
                <router-link :to="{ name: 'Detail', params: { id: dataList[0].id},query:{source:objProps.source}}">
                  <img :src="dataList[0].coverUrl?dataList[0].coverUrl:require('@/assets/img/defaultSchool.png')" width="100%">
                  <span :title="dataList[0].title">{{ dataList[0].title }}</span>
                </router-link>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="announcement_warp_right">
                <div v-for="item in dataList.slice(1)" :key="item.id" class="announcement-item">
                  <div class="announcement-item-main">
                    <router-link :to="{ name: 'Detail', params: { id: item.id},query:{source:objProps.source}}">
                      <div class="announcement-item-main-flex">
                        <div class="itemCoverUrl">
                          <img :src="item.coverUrl?item.coverUrl:require('@/assets/img/defaultSchool.png')">
                        </div>
                        <div style="flex: 1;margin:0 5px">
                          <div class="title">
                            <span :title="item.title">
                              {{ item.title }}
                            </span>
                          </div>
                          <div class="content">
                            <div class="text" :title="item.content" v-html="item.contentAbstract" />
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
        <global-empty
          v-else
          :label="`暂无数据~`"
          height="400"
          link-it="3"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NewsList',
  components: {
  },
  props: {
    dataList: {
      type: Array,
      default: () => []
    },
    informationType: {
      type: Array,
      default: () => []
    },
    objProps: {
      type: Object,
      default: () => {}
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.newsList{
  // margin-bottom: 30px;
    // .module-title {
    //   margin-bottom: 30px;
    // }
    .news-item-warp{
    background: #fff;
    border-radius: 8px;
    padding-bottom: 20px;
    }
    .news-item{
    // border-bottom: #ECECEC 1px dashed;
    // border-bottom: 1px solid transparent;
    // background: linear-gradient(white,white) padding-box,
    // repeating-linear-gradient(-45deg,#ECECEC 0, #ECECEC 0.30em,white 0,white 0.55em);
    padding:10px 20px;
    &:first-child{
      padding: 0px;

    }
    .coverUrl{
      width:100%;
      position:relative;
      overflow: hidden;
      border-radius: 8px;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      .image-warp{
        width: 590px;
        height: 332px;
        img{
          width: 100%;height: 100%;object-fit: contain;
          transform: scale(1);
          transition: transform 0.2s;
        }
        &:hover{
          // span{text-decoration: underline;}
          img{transform: scale(1.1);}
        }
      }
     .title-cover{
        width: 100%;
        color:#fff;
        background: linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,1));
        position: absolute;
        bottom: 0;
        left: 0;
        padding:20px;
        max-width: 590px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        vertical-align: middle;
        display: inline-block;
        -webkit-line-clamp: 1;
        }
    }
    a{
      display: inline-block;
      font-size: 16px;
    }
     &:hover a,&:hover .right{
      color: #334EB4;
      // text-decoration: underline;
    }
  }
  .news-item:not(:first-child) a{
      max-width: 475px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      vertical-align: middle;
      -webkit-line-clamp: 1;
    }
  .imgText{
  .message-main{
     .content{
      padding: 10px 0 20px 0;
    }
    .announcement{
      .coverUrl{
        height: 332px;
        margin-right: 30px;
        overflow: hidden;
        position: relative;
        span{
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          padding: 10px 0 10px 15px;
          box-sizing: border-box;
          color: #FFF;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.6));
          white-space: nowrap;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        img{
          transform: scale(1);
          transition: transform 0.2s;
        }
        &:hover{
          // span{text-decoration: underline;}
          img{transform: scale(1.1);}
        }
      }
      .announcement-item{
        color: #333;
        margin-bottom: 20px;
        border-bottom: 1px solid #F1F1F1;
        &:last-child{
           margin-bottom: 0px;
           border-bottom: 0
        }
         &:last-child .content{
          padding: 10px 0 0px 0;
        }
        &:hover{
          .title{color: #334EB4;}
          // .text{text-decoration: underline;}
        }
      }
    }
    .img{
      text-align: center;
      img{width: 100%;height: 100%;object-fit: contain;}
    }
      .title{
        span{
          max-height: 48px;
          font-weight: bold;
          width: 84%;
          white-space: nowrap;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          overflow: hidden;
          vertical-align: middle;
          display: inline-block;
          -webkit-line-clamp: 1;
          font-size: 20px;
        }
        color: #000;
      }
      .time{
        float: right;
        font-size: 14px;
        font-style: normal;
        line-height: 26px;
      }
      .text{
        width: 100%;
        font-size: 16px;
        line-height: 24px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
      }
      .more{
        color: #334EB4;
      }
    }
  }
  .imgTextUpDown{
  .message-main{
     .content{
      padding-top: 10px;
    }
    .announcement{
      // margin-top: 30px;
      .coverUrl{
        height: 332px;
        background: #fff;
        margin-right: 10px;
        overflow: hidden;
        position: relative;
        border-radius: 8px;
        span{
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          padding: 10px 0 10px 15px;
          box-sizing: border-box;
          color: #FFF;
          border-bottom-left-radius: 5px;
          border-bottom-right-radius: 5px;
          background: linear-gradient(to bottom, rgba(0,0,0,0), rgba(0,0,0,0.6));
          white-space: nowrap;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        img{
          width: 100%;height: 100%;object-fit: contain;
          transform: scale(1);
          transition: transform 0.2s;
        }
        &:hover{
          // span{text-decoration: underline;}
          img{transform: scale(1.1);}
        }
      }
    .announcement_warp_right{
      background: #fff;
      border-radius: 8px;
      height: 332px;
      border: 1px solid #fff;
    }
      .announcement-item{
        color: #666;
        padding: 7px 0;
        border-bottom: 1px solid #F1F1F1;
        &:last-child{
           border-bottom: 0
        }
         &:last-child .content{
          padding: 10px 0 0px 0;
        }
        &:hover{
          .title{color: #334EB4;}
          // .text{text-decoration: underline;}
        }
      }
    }
    .itemCoverUrl{
      margin:0 5px;
      width: 170px;
      height: 96px;
      overflow: hidden;
      border: 1px solid #F1F1F1;
      border-radius: 8px;
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }

    }
    .img{
      text-align: center;
      img{width: 100%;height: 100%;object-fit: contain;}
    }
      .title{
        span{
          max-height: 48px;
          font-weight: bold;
          width: 406px;
          white-space: nowrap;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
          overflow: hidden;
          vertical-align: middle;
          display: inline-block;
          -webkit-line-clamp: 1;
          font-size: 20px;
        }
        color: #333;
      }
      .time{
        float: right;
        font-size: 14px;
        font-style: normal;
        line-height: 26px;
      }
      .text{
        width: 100%;
        font-size: 16px;
        line-height: 24px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
      }
      .more{
        color: #334EB4;
      }
    }
  }
    .time{
         color: #9999;
      }
}
.announcement-item-main-flex{display: flex;align-items: center;}
</style>

